






































import { Component, Vue,Inject, Prop,Watch } from 'vue-property-decorator';
import Util from '../../../lib/util'
import AbpBase from '../../../lib/abpbase'
import {FieldType,Filter,CompareType} from '../../../store/entities/filter'
import PageRequest from '../../../store/entities/page-request'
import CreateRole from './create-role.vue'
import EditRole from './edit-role.vue'
@Component({
    components:{CreateRole,EditRole}
})
export default class Roles extends AbpBase{
	editData:any = {}
    edit(val:any){
		this.editData = val
        this.editModalShow=true;
    }
    filters:Filter[]=[
        {Type:FieldType.String,Value:'',FieldName:'Name',CompareType:CompareType.Contains},
        {Type:FieldType.String,Value:'',FieldName:'DisplayName',CompareType:CompareType.Contains},
        {Type:FieldType.DataRange,Value:'',FieldName:'Description',CompareType:CompareType.Contains}
    ]
    createModalShow:boolean=false;
    editModalShow:boolean=false;
    get list(){
        return this.$store.state.role.list;
    };
    get loading(){
        return this.$store.state.role.loading;
    }
    create(){
        this.createModalShow=true;
    }
    pageChange(page:number){
        this.$store.commit('role/setCurrentPage',page);
        this.getpage();
    }
    pagesizeChange(pagesize:number){
        this.$store.commit('role/setPageSize',pagesize);
        this.getpage();
    }
    async getpage(){
        let where= Util.buildFilters(this.filters);
        let pagerequest=new PageRequest();
        pagerequest.maxResultCount=this.pageSize;
        pagerequest.skipCount=(this.currentPage-1)*this.pageSize;
        pagerequest.where=where;
        await this.$store.dispatch({
            type:'role/getAll',
            data:pagerequest
        })
    }
    get pageSize(){
        return this.$store.state.role.pageSize;
    }
    get totalCount(){
        return this.$store.state.role.totalCount;
    }
    get currentPage(){
        return this.$store.state.role.currentPage;
    }
    columns=[{
        title:this.L('RoleName'),
        key:'name'
    },{
        title:this.L('DisplayName'),
        key:'displayName'
    },{
        title:this.L('Description'),
        key:'description'
    },{
        title:this.L('IsStatic'),
        render:(h:any,params:any)=>{
            return h('span',params.row.isStatic?'是':'否')
        }
    },{
        title:this.L('Actions'),
        key:'Actions',
        width:150,
        render:(h:any,params:any)=>{
            return h('div',[
                h('Button',{
                    props:{
                        type:'primary',
                        size:'small'
                    },
                    style:{
                        marginRight:'5px'
                    },
                    on:{
                        click:()=>{
                            this.$store.commit('role/edit',params.row);
                            this.edit(params.row);
                        }
                    }
                },this.L('Edit')),
                h('Button',{
                    props:{
                        type:'error',
                        size:'small'
                    },
                    on:{
                        click:async ()=>{
                            this.$Modal.confirm({
                                    title:this.L('Tips'),
                                    content:this.L('DeleteRolesConfirm'),
                                    okText:this.L('Yes'),
                                    cancelText:this.L('No'),
                                    onOk:async()=>{
                                        await this.$store.dispatch({
                                            type:'role/delete',
                                            data:params.row
                                        })
                                        await this.getpage();
                                    }
                            })
                        }
                    }
                },this.L('Delete'))
            ])
        }
    }]
    async created(){
        this.getpage();
        await this.$store.dispatch({
            type:'role/getAllPermissions'
        })
    }
}



// WEBPACK FOOTER //
// ./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/views/setting/role/role.vue